import { setStoreData } from '@/common/tolls.js'
var mutation = {
	setData(state, {data, field} ) {
		data && (state[field] = data);
	},
  setStoreData(state, { key, data}) {
  	setStoreData(state,key,data);
  },
}
export default mutation



// WEBPACK FOOTER //
// ./src/store/modules/analysis/mutation.js